import { getCurrentFortnight } from "./ReportByCranesOrders";

export const ReportByClerksOrder = () => {
  const { start, end } = getCurrentFortnight();
  return {
    start: start.toISOString().split("T")[0],
    end: end.toISOString().split("T")[0],
    clerk: "Todos",
    status: "Todas",
  };
}